import React, { Component } from 'react'
import { getBoundingClientRect } from '../../../utils/functions';
import { conditionalWidth, translate } from '../../../utils/useful';
import BottomSheet from '../../BottomSheet';
import ReportModal from '../../modals/ReportModal';
import Responsive from '../../Responsive';
import Slider from '../../slider/Slider';
import StagesManager from '../../StagesManager';
import Overview from './Overview';
import Privacy from './Privacy';
import Related from './Related';
import Reviews from './Reviews';
import Cookies from 'universal-cookie';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as actions from '../../../stores/actionsList';

class YonnectWorld extends Component {
    state = {
        card: [
            { title: "Now Available", name: "Genshin Impact", des: "The Windblume Festical Begins", img: "" }
        ],

        filter: [
            { title: "Featured", },
            { title: "Documents", },
            { title: "Pages", },
            { title: "Email", },
            { title: "Aplets", },
            { title: "Thired Party", },
            { title: "Developers", },
            { title: "Forms", },
            { title: "Automation", },
        ],

        indicatorWidth: null,
        indicatorLeft: 0,
        stage: 0,

        adbox2: [
            { img: "/images/v1.png" },
            { img: "/images/v1.png" },
            { img: "/images/v1.png" },
        ],

        adbox2lg: [
            { img: "/images/v1.png" },
            { img: "/images/v1.png" },
            { img: "/images/v1.png" },
            { img: "/images/v1.png" },
        ],

        adbox: [
            { img: "/images/s1.png" },
            { img: "/images/s2.png" },
            // { img: "/images/s1.png" },
        ],

        adboxlg: [
            { img: "/images/s1.png" },
            { img: "/images/s2.png" },
            { img: "/images/s1.png" },
        ],

        items: [
            { icon: "/images/p1.png", title: 'Survivor!.io', des: "Survive the fun!" },
            { icon: "/images/p2.png", title: 'Subway Surfers', des: "Join the endless running fun!" },
            { icon: "/images/p3.png", title: 'Dumb Way to Die', des: "Safety First" },
            { icon: "/images/p4.png", title: 'CSR 2 Drag Racing Car Games', des: "Racing Games Driving Simulator" },
            { icon: "/images/p5.png", title: 'Pivote Table', des: "Build visualization using Vega-Lite" },
            { icon: "/images/p6.png", title: 'Dumb Way to Die', des: "Safety First" },
            { icon: "/images/p7.png", title: 'CSR 2 Drag Racing Car Games', des: "Racing Games Driving Simulator" },
            { icon: "/images/p8.png", title: 'Pivote Table', des: "Build visualization using Vega-Lite" },
            { icon: "/images/p1.png", title: 'Survivor!.io', des: "Survive the fun!" },
            { icon: "/images/p2.png", title: 'Subway Surfers', des: "Join the endless running fun!" },
            { icon: "/images/p3.png", title: 'Dumb Way to Die', des: "Safety First" },
            { icon: "/images/p4.png", title: 'CSR 2 Drag Racing Car Games', des: "Racing Games Driving Simulator" },
            { icon: "/images/p5.png", title: 'Pivote Table', des: "Build visualization using Vega-Lite" },
            { icon: "/images/p6.png", title: 'Dumb Way to Die', des: "Safety First" },
            { icon: "/images/p7.png", title: 'CSR 2 Drag Racing Car Games', des: "Racing Games Driving Simulator" },
            // { icon: "/images/p8.png", title: 'Pivote Table', des: "Build visualization using Vega-Lite" },
        ],

        tabs: [
            { title: "Overview", key: "overview" },
            { title: "Privacy practices", key: "privacy" },
            { title: "Reviews", key: "reviews" },
            // { title: "Support", key: "support" },
            { title: "Related", key: "related" },
        ],

        info: [
            { title: "Offered by", des: "zoom.us" },
            { title: "Version", des: "1.8.13" },
            { title: "Updated", des: "March 6, 2023" },
            { title: "Size", des: "235KiB" },
            { title: "Languages", des: "English, French, Spanish" },
            { title: "Developer", des: "This developer has identified itself as a trader per the definition from the European Union." },

        ],
        tab: 'overview'

    }

    componentDidMount() {
        const cookies = new Cookies();
        let token = cookies.get('token');
        if (token) {
            this.setState({ isLoading: true })
            this.waitForId(10)
        } else {
            this.setState({ pageStatus: 401 })
        }
        console.log('baseurllllllllllllll', this.props.baseUrl)
        this.changeStage(0, this['indicator-0'])
    }

    componentDidUpdate(prevProps) {
        if ((this.state.oldData && JSON.stringify(this.state.oldData) != JSON.stringify(this.props.windowData))) {
            this.setState({ oldData: this.props.windowData }, () => {
            })
        }
    }

    waitForId = (leftAttempt) => {
        if (this.props.user?.info?._id) {
            this.setState({ isLoading: false }, () => {
                this.setState({ oldData: this.props.windowData }, () => {
                })
            })
        } else {
            setTimeout(() => {
                if (leftAttempt != 0) {
                    this.waitForId(leftAttempt - 1)
                } else {
                    this.setState({ pageStatus: 401 })
                }
            }, 500);
        }
    }

    changeStage = (index, target) => {

        let bound = getBoundingClientRect(target)
        let containerBound = getBoundingClientRect(this.indicatorContainer)
        console.log(bound)
        this.setState({ indicatorLeft: bound.left - containerBound.left, indicatorWidth: bound.width })
    }

    openSingle = () => {

        this.bottomSheet.open()
        // this.setState({ currentItem: item })
    }

    changeTab = (prop) => {
        this.stageManager.changeStage(prop.key)
        this.setState({ tab: prop.key })
    }

    render() {
        return (
            <div className='w-100 window-content-radius h-100 d-flex flex-column scroll-no-scrollbar'>
                <div className='d-flex flex-wrap'>
                    <Responsive width={this.props.width} media={this.props.col ?? { xs: "none", lg: "2" }}>
                        <div className='w-100 h-100' style={{ backgroundColor: "#f6f6f6" }}>
                            <div className='position-sticky top-0 py-4 px-3'>
                                <div className=' navbar-search2 py-2 px-3 br-10 '>
                                    <div className='d-flex flexcb'>
                                        <input className="w-100" onChange={e => this.changeValue(e)} value={this.state.search} type="text" placeholder={translate(`Search in Yonnect and beyond`)} style={{ backgroundColor: 'transparent', }} />
                                        <img style={{ width: '25px', height: '25px' }} src="/images/icons/search.svg" />
                                    </div>
                                </div>
                                <div className='mt-3'>
                                    {this.state.filter.map((prop, index) => {
                                        return (
                                            <div>
                                                <button className='py-2 yw-side br-5 px-2 my-1 w-100'>
                                                    <p className='text-start font-size-12'>{prop.title}</p>
                                                </button>
                                            </div>
                                        )
                                    })}
                                </div>
                            </div>
                        </div>
                    </Responsive>
                    <Responsive width={this.props.width} media={this.props.col ?? { xs: "12", lg: "10" }}>
                        <div>
                            <Slider />
                        </div>
                        <div className={' flexc mx-4 position-relative ' + conditionalWidth(this.props.width, { xs: '', lg: ' d-none ' })} ref={el => this.indicatorContainer = el} style={{ borderBottom: "1px solid #eee" }}>
                            {this.state.filter.map((prop, index) => {
                                return (
                                    <div>
                                        <button className='py-2 mrd-8' ref={el => this['indicator-' + index] = el} onClick={(e) => this.changeStage(index, e.target)}>
                                            <p className=''>{prop.title}</p>
                                        </button>
                                    </div>
                                )
                            })}
                            {this.state.indicatorWidth && (
                                <div className="transition-all br-20" style={{ background: '#0073ee', width: this.state.indicatorWidth, left: this.state.indicatorLeft, height: 2, bottom: 0, position: 'absolute' }}></div>
                            )}
                        </div>
                        <div className={' navbar-search mx-4 mt-4 py-2 px-3 br-10 ' + conditionalWidth(this.props.width, { xs: '', lg: ' d-none ' })}>
                            <div className='d-flex flexcb'>
                                <input className="w-100" onChange={e => this.changeValue(e)} value={this.state.search} type="text" placeholder={translate(`Search in Yonnect and beyond`)} style={{ backgroundColor: 'transparent', }} />
                                <img style={{ width: '25px', height: '25px' }} src="/images/icons/search.svg" />
                            </div>
                        </div>

                        <div className={' mx-4 flexc mt-3 ' + conditionalWidth(this.props.width, { xs: '  ', lg: ' d-none ' })} style={{ gap: "10px" }}>
                            {this.state.adbox.map((prop, index) => {
                                return (
                                    <div>
                                        <button className=' br-15 h-100 w-100 ' style={{ backgroundColor: "#f6f6f6", }}>
                                            <img className='w-100' style={{ objectFit: "cover" }} src={prop.img} />
                                        </button>
                                    </div>
                                )
                            })}
                        </div>

                        <div className={' mx-4 flexc mt-3 ' + conditionalWidth(this.props.width, { xs: ' d-none ', lg: '  ' })} style={{ gap: "10px" }}>
                            {this.state.adboxlg.map((prop, index) => {
                                return (
                                    <div>
                                        <button className=' br-15 h-100 w-100 ' style={{ backgroundColor: "#f6f6f6", }}>
                                            <img className='w-100' style={{ objectFit: "cover" }} src={prop.img} />
                                        </button>
                                    </div>
                                )
                            })}
                        </div>

                        <div className='flexcb mx-4 pt-2 mt-4' style={{ borderTop: "1px solid #eee" }}>
                            <p className='weight-500 font-size-16' style={{ color: "#333" }}>Extensions by Yonnect</p>
                            <button className='flexc'>
                                <p className='font-size-12' style={{ color: "#0073ee" }}>View All</p>
                                <img width={22} style={{ rotate: "180deg" }} src='/assets/icons/arrow-left-blue.svg' />
                            </button>
                        </div>
                        <div className='d-flex flex-wrap pt-2 px-4'>
                            {this.state.items.map((prop, index) => {
                                return (
                                    <Responsive width={this.props.width} media={this.props.col ?? { xs: "6", lg: "4" }}>
                                        <div className={'flexcb p-1 my-1 br-10 cursor-pointer ' + (index % conditionalWidth(this.props.width, { xs: ' 2 ', lg: ' 3 ' }) == 0 ? "mrd-2" : "mld-2")} style={{ backgroundColor: "#f6f6f6", border: "1px solid #f5f5f5" }} onClick={() => this.openSingle()}>
                                            <div className='flexc'>
                                                <img className='br-5' width={50} src={prop.icon} />
                                                <div className='mld-3'>
                                                    <p className='font-size-14' style={{ color: "#333" }}>{prop.title}</p>
                                                    <p className='font-size-10' style={{ color: "#888" }}>{prop.des}</p>
                                                </div>
                                            </div>
                                            <button className='px-3 br-5 py-2 mrd-3' style={{ backgroundColor: "#eee" }}>
                                                <p className='font-size-12' style={{ color: "#0073ee" }}>Add</p>
                                            </button>
                                        </div>
                                    </Responsive>
                                )
                            })}
                        </div>
                        <div className={' mx-4 flexc mt-3 ' + conditionalWidth(this.props.width, { xs: '', lg: ' d-none ' })} style={{ gap: "10px" }}>
                            {this.state.adbox.map((prop, index) => {
                                return (
                                    <div>
                                        <button className=' br-15 h-100 w-100 ' style={{ backgroundColor: "#f6f6f6", }}>
                                            <img className='w-100' style={{ objectFit: "cover" }} src={prop.img} />
                                        </button>
                                    </div>
                                )
                            })}
                        </div>
                        <div className={' mx-4 flexc mt-3 ' + conditionalWidth(this.props.width, { xs: '', lg: ' d-none ' })} style={{ gap: "10px" }}>
                            {this.state.adbox2.map((prop, index) => {
                                return (
                                    <div>
                                        <button className=' br-15 h-100 w-100 ' style={{ backgroundColor: "#f6f6f6", }}>
                                            <img className='w-100' style={{ objectFit: "cover" }} src={prop.img} />
                                        </button>
                                    </div>
                                )
                            })}
                        </div>
                        <div className='flexcb mx-4 pt-2 mt-4' style={{ borderTop: "1px solid #eee" }}>
                            <p className='weight-500 font-size-16' style={{ color: "#333" }}>Third Party</p>
                            <button className='flexc'>
                                <p className='font-size-12' style={{ color: "#0073ee" }}>View All</p>
                                <img width={22} style={{ rotate: "180deg" }} src='/assets/icons/arrow-left-blue.svg' />
                            </button>
                        </div>
                        <div className={' mx-4 flexc mt-3 ' + conditionalWidth(this.props.width, { xs: ' d-none ', lg: '  ' })} style={{ gap: "10px" }}>
                            {this.state.adboxlg.map((prop, index) => {
                                return (
                                    <div>
                                        <button className=' br-15 h-100 w-100 ' style={{ backgroundColor: "#f6f6f6", }}>
                                            <img className='w-100' style={{ objectFit: "cover" }} src={prop.img} />
                                        </button>
                                    </div>
                                )
                            })}
                        </div>
                        <div className={' mx-4 flexc mt-3 ' + conditionalWidth(this.props.width, { xs: ' d-none ', lg: '  ' })} style={{ gap: "10px" }}>
                            {this.state.adbox2lg.map((prop, index) => {
                                return (
                                    <div>
                                        <button className=' br-15 h-100 w-100 ' style={{ backgroundColor: "#f6f6f6", }}>
                                            <img className='w-100' style={{ objectFit: "cover" }} src={prop.img} />
                                        </button>
                                    </div>
                                )
                            })}
                        </div>
                        <div className='d-flex flex-wrap pt-2 px-4'>
                            {this.state.items.map((prop, index) => {
                                return (
                                    <Responsive width={this.props.width} media={this.props.col ?? { xs: "6", lg: "4" }}>
                                        <div className={'flexcb p-1 my-1 br-10 cursor-pointer ' + (index % conditionalWidth(this.props.width, { xs: ' 2 ', lg: ' 3 ' }) == 0 ? "mrd-2" : "mld-2")} style={{ backgroundColor: "#f6f6f6", border: "1px solid #f5f5f5" }} onClick={() => this.openSingle()}>
                                            <div className='flexc'>
                                                <img className='br-5' width={50} src={prop.icon} />
                                                <div className='mld-3'>
                                                    <p className='font-size-14' style={{ color: "#333" }}>{prop.title}</p>
                                                    <p className='font-size-10' style={{ color: "#888" }}>{prop.des}</p>
                                                </div>
                                            </div>
                                            <button className='px-3 br-5 py-2 mrd-3' style={{ backgroundColor: "#eee" }}>
                                                <p className='font-size-12' style={{ color: "#0073ee" }}>Add</p>
                                            </button>
                                        </div>
                                    </Responsive>
                                )
                            })}
                        </div>
                    </Responsive>
                </div>
                <BottomSheet ref={el => this.bottomSheet = el} width={this.props.width}>
                    <div className='d-flex flex-wrap'>
                        <Responsive width={this.props.width} media={this.props.col ?? { xs: "8", }}>
                            <div className='p-4'>
                                <div className='flexc'>
                                    <img width={60} className='br-10' src='/images/p1.png' />
                                    <div className='mld-3'>
                                        <div className='flexc'>
                                            <p className='font-size-20 weight-700' style={{ color: "#333" }}>Vega-Lit</p>
                                            <img className='mld-3' width={20} src='/assets/icons/aproved.svg' />
                                        </div>
                                        <p className='font-size-12' style={{ color: "#999" }}>Build visualizations using Vega-Lite</p>
                                    </div>
                                </div>
                                <div className='flexc mt-4'>
                                    <div className='flexc'>
                                        <img width={20} src='/assets/icons/star.svg' />
                                        <img width={20} src='/assets/icons/star.svg' />
                                        <img width={20} src='/assets/icons/star.svg' />
                                        <img width={20} src='/assets/icons/star.svg' />
                                        <img width={20} src='/assets/icons/star-empty.svg' />
                                        <p className='mld-3' style={{ color: "#777" }}>2,034</p>
                                    </div>
                                    <p className='font-size-12 mld-5 pld-5' style={{ color: "#777" }}>Categories</p>
                                    <p className='font-size-12 mld-5 pld-5' style={{ color: "#777" }}>20,000 User</p>
                                </div>
                                <div className='mt-3' style={{ maxWidth: "600px" }}>
                                    <p className='font-size-12' style={{ color: "#777" }}>This is a test discription about Yonnect extention which will be going be a long discription therefor I'm just typing for the sake of making it long</p>
                                </div>
                                <div className='flexc pb-3 mt-3' style={{}}>
                                    {this.state.tabs.map((prop, index) => {
                                        return (
                                            <button className={' br-5 px-3 py-2 mrd-5 ' + (prop.key == this.state.tab ? ' blue-border ' : '')} style={{ backgroundColor: "#f6f6f6", }} onClick={() => this.changeTab(prop)}>
                                                <p style={{ whiteSpace: "nowrap" }}>{prop.title}</p>
                                            </button>
                                        )
                                    })}
                                </div>
                            </div>
                            <Responsive className={"p-0"} width={this.props.width} media={this.props.col ?? { xs: "12", }}>
                                <div className='' style={{ borderTop: "1px solid #eee" }}>
                                    <StagesManager ref={el => this.stageManager = el} fast={true}>
                                        <Overview width={this.props.width} height={"100%"} changeStage={this.changePage} stage={0} stageName={'overview'} />
                                        <Privacy width={this.props.width} height={"100%"} changeStage={this.changePage} stage={1} stageName={'privacy'} />
                                        <Reviews width={this.props.width} height={"100%"} changeStage={this.changePage} stage={1} stageName={'reviews'} />
                                        <Related width={this.props.width} height={"100%"} changeStage={this.changePage} stage={1} stageName={'related'} />
                                    </StagesManager>
                                </div>
                            </Responsive>
                        </Responsive>
                        <Responsive width={this.props.width} media={this.props.col ?? { xs: "4", }}>
                            <div className=' p-4 position-sticky top-0'>
                                <div className="">
                                    <button className='blue-btn px-3 py-2 br-10'>
                                        <p className='white font-size-14 weight-500'>Add extention</p>
                                    </button>
                                </div>
                                <div className='mt-4'>
                                    <p className='font-size-14 weight-500' style={{ color: "#333" }}>Publisher</p>
                                    <div className='flexc mt-2'>
                                        <img className='br-5' width={30} src='/images/p2.png' />
                                        <p className='font-size-12 mld-3' style={{ color: "#777" }}>Yonnect.inc</p>
                                    </div>
                                </div>
                                <div className='flexcb'>
                                    <div>
                                        <p className='link-text mt-4 font-size-12'>Contact Publisher</p>
                                        <p className='link-text mt-2 font-size-12'>Support Website</p>
                                    </div>
                                    <div className='mt-4'>
                                        <p className='font-size-14 weight-500' style={{ color: "#333" }}>Last Updated</p>
                                        <p className='font-size-12 mt-2' style={{ color: "#777" }}>Jun 16th, 2022</p>
                                    </div>
                                </div>
                                <div className='mt-4'>
                                    <p className='font-size-14 weight-500' style={{ color: "#333" }}>Additional Information</p>
                                    <div className='flexc mt-4'>
                                        <button className='flexc'>
                                            <img width={20} src='/assets/icons/web.svg' />
                                            <p className='mld-3' style={{ color: "#007AFF" }}>Website</p>
                                        </button>
                                        <button className='flexc mld-5' onClick={() => this.reportModal.modal.showModal()}>
                                            <img width={20} src='/assets/icons/report.svg' />
                                            <p className='mld-3' style={{ color: "#E62323" }}>Report</p>
                                        </button>
                                    </div>
                                    <div className='mt-3'>
                                        {this.state.info.map((prop, index) => {
                                            return (
                                                <div>
                                                    <p className='font-size-12 weight-500' style={{ color: "#444" }}>{prop.title}</p>
                                                    <p className='font-size-10 weight-300 pt-2 pb-4' style={{ color: "#777" }}>{prop.des}</p>
                                                </div>
                                            )
                                        })}
                                    </div>
                                </div>
                            </div>
                        </Responsive>
                    </div>
                </BottomSheet >
                <ReportModal width={this.props.width} closeModal={() => this.reportModal.modal.hideModal()} ref={el => this.reportModal = el} data={this.state?.course} />
            </div >
        )
    }
}


const mapStateToProps = state => ({ settings: state.settings, user: state.user })
const mapDispatchToProps = dispatch => ({ actions: bindActionCreators(actions, dispatch) })

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(YonnectWorld);